import { createSelector } from 'reselect';

import { getBodyData } from 'store/selectors';
import { getBasketProductIds } from 'store/common/basket/selectors';

export const getRecentlyViewedProductsData = (state) =>
  getBodyData(state).recentlyViewedProducts || {};

export const isRecentlyViewedProductsEnabled = (state) =>
  getRecentlyViewedProductsData(state).isEnabled;

export const getRecentlyViewedProductsPayload = (state) =>
  getRecentlyViewedProductsData(state).payload || {};

// recently products cookie data
export const getRecentlyViewedProductsStorage = (state) =>
  getRecentlyViewedProductsData(state).storage || {};
export const getRecentlyViewedProductsCookieName = (state) =>
  getRecentlyViewedProductsStorage(state).cookieName;
export const getRecentlyViewedProductsCookieMaxCount = (state) =>
  getRecentlyViewedProductsStorage(state).maxCount;
export const getRecentlyViewedProductsCookieDuration = (state) =>
  getRecentlyViewedProductsStorage(state).cookieDuration;

export const getRecentlyViewedProductsAvailability = (state) =>
  !!getRecentlyViewedProductsData(state);

export const getRecentlyViewedProductsHeadline = (state) => {
  if (getRecentlyViewedProductsPayload(state)) {
    return getRecentlyViewedProductsPayload(state).headerText;
  }
  return '';
};

// eslint-disable-next-line max-len
export const getRecentlyViewedProductShowIndex = (state) =>
  getRecentlyViewedProductsPayload(state).recentNewShowIndex || '';
export const getRecentlyViewedButtonText = (state) =>
  getRecentlyViewedProductsPayload(state).buttonText || '';
// eslint-disable-next-line max-len
export const getRecentlyViewedActiveButtonText = (state) =>
  getRecentlyViewedProductsPayload(state).activeButtonText || '';

/** Selectors for summary cross sell item list */
export const getRecentlyViewedProductsListRaw = (state) =>
  getRecentlyViewedProductsPayload(state).products || [];
export const getRecentlyViewedProductsList = createSelector(
  getRecentlyViewedProductsListRaw,
  getBasketProductIds,
  (list, addedItems) =>
    list.map(({ id, slug, price, ...otherFields }, index) => ({
      ...otherFields,
      price,
      discount: Math.max(price.oldValue - price.value, 0) || 0,
      position: index + 1,
      isInBasket: addedItems.includes(id.toString()),
      id,
      url: slug,
    })),
);
